
import './App.css';
import { MainLayout } from './components/Layout/Layout';

function App() {
  return (
    <div className="App">
      <MainLayout />     
    </div>
  );
}

export default App;
